"use strict";

import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "axios";
import langPt from "@/locales/pt";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: "pt",
  fallbackLocale: "pt",
  messages: {
    pt: langPt.messages
  },
  dateTimeFormats: {
    pt: langPt.dateTimeFormats
  }
});

const loadedLanguages = ["pt"];

function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  return import(
    /* webpackChunkName: "lang-[request]" */ `@/locales/${lang}.json`
  )
    .then(langFile => {
      i18n.setLocaleMessage(lang, langFile.default.messages);
      i18n.setDateTimeFormat(lang, langFile.default.dateTimeFormats);
      loadedLanguages.push(lang);
      return setI18nLanguage(lang);
    })
    .catch(err => {
      if (lang.indexOf("-") > -1) {
        const mainLang = lang.split("-")[0];
        // eslint-disable-next-line no-console
        console.warn(
          `Cannot find language file for ${lang} falling back to ${mainLang}`
        );
        loadLanguageAsync(mainLang);
      } else {
        console.error(err); // eslint-disable-line no-console
      }
    });
}
